





















































import { Prop, Component, Vue } from 'vue-property-decorator'
import { Comment } from '@/api/model/comment'
import { User } from '@/api/model/user'
import { escapeHtml, sanitizeHtml } from '@/helpers/html'
import { renderTypedMentionsInHtml } from '@/helpers/comment-text'

@Component
export default class Comments extends Vue {
    @Prop() readonly comments!: Comment[]
    @Prop({ default: () => []}) readonly mentionableUsers!: User[]
    @Prop({ type: Boolean, default: false }) canDelete!: boolean

    isOwnComment(comment: Comment): boolean {

        // Skip KeyVue user (= null)
        if (comment.user === null) {
            return false
        }

        return this.$currentUser.id === comment.user.id
    }

    renderComment(comment: string): string {
        // A plain "@Name" is shown as a mention, by the rule of a typed mention in the edit box (as in CommentBlock);
        // keyvue-mention is in the whitelist (and styled in App.vue). Sanitized last, so neither the stored comment
        // nor a name can add markup.
        return sanitizeHtml(renderTypedMentionsInHtml(comment, this.mentionableUsers,
            user => `<span class="keyvue-mention">${escapeHtml(user.name)}</span>`))
    }

    async deleteComment(comment: Comment): Promise<void> {
        this.$emit('delete', comment)
    }

    get sortedComments() {
        return this.comments
            .filter(comment => comment instanceof Comment)
            .sort((a: Comment, b: Comment) => a.createdAt > b.createdAt ? -1 : 1)
    }
}
